import { useMutation } from '@tanstack/react-query';

import { getSMPBackendAPIAdmin } from '@/proxy';

function declineJobRequest(id: string) {
  return getSMPBackendAPIAdmin().resourceBookingsControllerDeclineRequestedServiceBookingV1(id);
}

export function useDeclineJobRequest() {
  return useMutation({ mutationFn: declineJobRequest });
}
